import $ from 'jquery';

const MobileMenu = (el) => {
    const $el = $(el);


    $el.click(function (e) {
        e.preventDefault();

        $('body').toggleClass('js-state-menu-open');
        $el.toggleClass('js-state-menu-open');

        if($el.hasClass('js-state-menu-open'))  {
            $el.attr('aria-expanded', 'true');
        }  else {
            $el.attr('aria-expanded', 'false');
        }

        if($el.data('toggle') !== undefined) {
            $($el.data('toggle')).toggleClass('js-state-menu-open');
        }
    });
};

export default MobileMenu;
